import util from "../util";

const theme = { ...util };

export default theme;
